import { render, staticRenderFns } from "./ModalAdicionarConta.vue?vue&type=template&id=87182694&"
import script from "./ModalAdicionarConta.vue?vue&type=script&lang=js&"
export * from "./ModalAdicionarConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports